import useFeatureFlags from 'common/hooks/useFeatureFlags';

export const useListingManagerMaintenanceMode = () => {
  const { data: featureFlags, isInitialLoading } = useFeatureFlags(['enable_listing_manager_maintenance_mode'], {});

  return {
    isMaintenanceModeEnabled: featureFlags?.enable_listing_manager_maintenance_mode === 'on',
    isMaintenanceModeEnabledLoading: isInitialLoading,
  };
};
